function SvgPlusV2(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M19.3792 10.0003C19.3792 10.4271 19.0333 10.7731 18.6065 10.7731L10.7728 10.7731V18.6068C10.7728 19.0336 10.4268 19.3796 10 19.3796C9.57322 19.3796 9.22725 19.0336 9.22725 18.6068V10.7731L1.39351 10.7731C0.966732 10.7731 0.620758 10.4271 0.620758 10.0003C0.620759 9.57355 0.966732 9.22758 1.39351 9.22758L9.22725 9.22758L9.22725 1.39385C9.22725 0.967068 9.57322 0.621094 10 0.621094C10.4268 0.621094 10.7728 0.967068 10.7728 1.39385L10.7728 9.22758H18.6065C19.0333 9.22758 19.3792 9.57355 19.3792 10.0003Z"
        fill="#004BB0"
      />
    </svg>
  )
}

export default SvgPlusV2
